import CheckedIcon from '@mui/icons-material/Check';
import { Box, Chip, Divider, FormControlLabel as FormControlLabelMui, Typography, styled } from '@mui/material';

export const FilterSection = styled(Box)({
  padding: '8px 0'
});

export const FilterSectionTitle = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '160%',
  letterSpacing: '0.15px',
  color: '#000000',
  marginBottom: '8px'
});

export const Separator = styled(Divider)({
  margin: '16px 0'
});

export const IconChecked = styled(CheckedIcon)({
  fontSize: 'small',
  marginRight: '5px'
});

export const SelectedFilterChip = styled(Chip)({
  backgroundColor: 'transparent',
  border: '1px solid rgba(6, 117, 221, 0.5);',
  borderRadius: '4px',
  color: '#0259AB',
  marginRight: '8px'
});

export const FormControlLabel = styled(FormControlLabelMui)({
  '.MuiTypography-root': {
    fontSize: '13px',
    color: '#000000'
  }
});
